import { deleteRequest, postRequest } from '../requests';

export interface ProviderAuthorizeUrlRequest {
    ProviderID: string;
    LoginState: {
        FinalRedirectPath: string | null;
        ExistingAccountID: string | null;
        SuppressErrorPage: boolean;
    };
    RedirectUriFallback: string;
}

export interface ProviderAuthorizeUrlResponse {
    AuthorizeUrlWithQuery: string;
}

export async function getProviderAuthorizeUrl(
    request: ProviderAuthorizeUrlRequest,
): Promise<ProviderAuthorizeUrlResponse> {
    return postRequest('api/cfhrprovideraccounts/providerauthorizeurl', request);
}

export async function fetchProviderAccountData(accountID: string): Promise<void> {
    return postRequest(`api/cfhrprovideraccounts/fetchaccountdata/${accountID}`, {});
}

export async function deleteProviderAccount(accountID: string): Promise<void> {
    return deleteRequest(`api/cfhrprovideraccounts/account/${accountID}?deleteData=true`);
}